export default __webpack_public_path__ + "static/media/rectangle.ba5c4b84.svg";